// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"ec991a5416bf37d2b0e8","883":"1c18a2ed3da96de7fa38"}[chunkId] + ".js";
};